module.exports = __webpack_public_path__ + "img/20210906-1630913500838730.9d69e77f.png";